export default __webpack_public_path__ + "static/media/report.c065b2c7.svg";